import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { isArray } from 'rev-shared/util';

import { VbAuthorizationBaseAngular } from './VbAuthorizationBaseAngular';
import { SecurityContextService } from './SecurityContext.Service';

/**
 * vbAuthorizationKey
 * Input is an authorization key string supplied as a value to vbAuthorizationKey.
 * Functions like ng-if where the condition is if you are authorized.
 * <div *vbAuthorizationKey="'teams.add'">Content</div>
 *
 * To provide fallback content to users who do not have authorization, add an else templateRef in the same style as *ngIf.
 * <div *vbAuthorizationKey="'teams.add'; else elseTemplateRef">Content</div>
 * <ng-template #elseTemplateRef>Else content!</ng-template>
 *
 * To surface the content if the user does not have the given authorization, supply the `fallback` arg to the structual directive.
 * <div *vbAuthorizationKey="'teams.add'; fallback true">Content</div>
 */
@Directive({
	selector: '[vbAuthorizationKey]'
})
export class VbAuthorizationKeyAngularDirective extends VbAuthorizationBaseAngular {
	@Input() public vbAuthorizationKey: string | string[];

	/**
	 * To use, set the 'fallback' variable to true: *ngAuthorizationKey="'teams.add'; fallback true"
	 * Inverts the check to show content as a fallback,  when the user does NOT have permission.
	 */
	@Input() public vbAuthorizationKeyFallback: boolean;
	@Input('vbAuthorizationKeyElse') public elseTemplateRef: TemplateRef<HTMLElement>;

	constructor(
		private SecurityContext: SecurityContextService,
		templateRef: TemplateRef<HTMLElement>,
		viewContainer: ViewContainerRef
	) {
		super(templateRef, viewContainer);
	}

	public checkPermission(): boolean {
		const keys = isArray(this.vbAuthorizationKey) ? this.vbAuthorizationKey : [this.vbAuthorizationKey];
		const hasPermission = this.SecurityContext.checkAuthorizations(keys);

		return this.vbAuthorizationKeyFallback ? !hasPermission : hasPermission;
	}
}
